import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            {/* Mega Footer */}
            <div className="mega-footer">
              <div className="row">
                {/* About */}
                <div className="col-lg-6 col-md-12">
                  <div className="footer-about">
                    <figure>
                      <img
                        src="/assets/images/healthtechlogo.png"
                        alt="Healthtech Logo"
                        width="220"
                      />
                    </figure>
                    <p>Connecting Science. Creating Impact.</p>
                    <ul style={{ lineHeight: "1.2" }}>
                      <li>
                        ceo@healthtechsl.com
                      </li>
                      <li> sales@healthtechsl.com</li>
                      <li>+91 82910 74273</li>
                       <li>+91 74004 38578</li>
                    </ul>
                  </div>
                </div>

                {/* Pages */}
                <div className="col-lg-2 col-md-4">
                  <div className="footer-links">
                    <h2>pages</h2>
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/about-us">About Us</Link>
                      </li>
                      <li>
                        <Link to="/services">Services</Link>
                      </li>
                      <li>
                        <Link to="/blogs">Blogs</Link>
                      </li>
                      <li>
                        <Link to="/contact-us">Contact Us</Link>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Socials */}
                <div className="col-lg-2 col-md-4">
                  <div className="footer-links">
                    <h2>Socials</h2>
                    <ul className="social-links">
                      <li>
                        <a
                          href="https://www.instagram.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Instagram
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.facebook.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Facebook
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://twitter.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Twitter
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.linkedin.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          LinkedIn
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Services */}
                <div className="col-lg-2 col-md-4">
                  <div className="footer-links">
                    <h2>services</h2>
                    <ul>
                      <li>
                        <Link to="services/digital-marketing-strategy">
                          Digital Marketing Strategy
                        </Link>
                      </li>
                      <li>
                        <Link to="services/website-and-software-development">
                          Website & Software Development
                        </Link>
                      </li>
                      <li>
                        <Link to="services/brand-building">Brand Building</Link>
                      </li>
                      <li>
                        <Link to="services/data-analytics">Data Analytics</Link>
                      </li>
                      <li>
                        <Link to="services/social-media-management">
                          Social Media Management
                        </Link>
                      </li>
                      <li>
                        <Link to="services/healthtech-specific-solutions">
                          Healthtech Specific Solutions
                        </Link>
                      </li>
                      <li>
                        <Link to="services/support-and-managed-services">
                          Support & Managed Services
                        </Link>
                      </li>
                      <li>
                        <Link to="services/cloud-solutions">
                          Cloud Solutions
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Copyright */}
            <div className="footer-copyright">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="footer-copyright-text">
                    <p>
                      Copyright © 2025 Healthtech Solutions Pvt Ltd. All rights
                      reserved.
                    </p>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="footer-policy-links">
                    <ul>
                      <li>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/terms-conditions">Terms of Service</Link>
                      </li>
                      <li>
                        <Link to="/faqs">FAQs</Link>
                      </li>
                      <li className="highlighted">
                        <a href="#top">Go to Top</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
